/// <amd-module name="Mention/TestEditor/TextAreaEditor" />
import * as React from "react";
import { VssComponent, IVssComponentContext, WrappedComponent } from "VSS/Platform/Layout";
import { IAutocompleteComponent } from "Mention/Autocomplete/Contracts";

interface TextAreaEditorProps {}

interface TextAreaEditorState {
    value: string;
    rows: number;
    minRows: number;
    maxRows: number;
}

// Temporary editor to be replaced with a markdown editor
export class TextAreaEditor extends VssComponent<TextAreaEditorProps, TextAreaEditorState> {
    private _textAreaElement: HTMLTextAreaElement;
    private _isAutocompleteComponentBound: boolean = false;
    private _autocompleteComponent: IAutocompleteComponent;

    constructor(props: TextAreaEditorProps, context: IVssComponentContext) {
        super(props, context);

        this.state = {
            value: "",
            rows: 5,
            minRows: 5,
            maxRows: 20
        };
    }

    public componentDidMount(): void {
        super.componentDidMount();

        this._bindAutocompleteComponent();
    }

    private handleChange = (event: { target: { rows: number; scrollHeight: number; scrollTop: any; value: any } }) => {
        const textareaLineHeight = 24;
        const { minRows, maxRows } = this.state;

        const previousRows = event.target.rows;
        event.target.rows = minRows; // reset number of rows in textarea

        const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);

        if (currentRows === previousRows) {
            event.target.rows = currentRows;
        }

        if (currentRows >= maxRows) {
            event.target.rows = maxRows;
            event.target.scrollTop = event.target.scrollHeight;
        }

        this.setState({
            value: event.target.value,
            rows: currentRows < maxRows ? currentRows : maxRows
        });
    };

    public render(): JSX.Element {
        return (
            <div>
                <textarea
                    rows={this.state.rows}
                    value={this.state.value}
                    placeholder={"Add a comment..."}
                    className={"textarea"}
                    onChange={this.handleChange}
                    style={{ width: "100%" }}
                    ref={this._setTextAreaRef}
                />

                <WrappedComponent wrappedType={"autocomplete-component"} wrappedRef={this._setAutocompleteComponent} dependencies={["ms.vss-mention.mention-autocomplete"]} />
            </div>
        );
    }

    private _setTextAreaRef = (textAreaRef: HTMLTextAreaElement) => {
        this._textAreaElement = textAreaRef;
    };

    private _setAutocompleteComponent = (autocompleteComponent: IAutocompleteComponent): void => {
        this._autocompleteComponent = autocompleteComponent;
        this._bindAutocompleteComponent();
    };

    private _bindAutocompleteComponent(): void {
        if (this._isAutocompleteComponentBound) {
            return;
        }

        // bind div to plugin only when both plugin & div are initialized
        if (this._autocompleteComponent && this._textAreaElement) {
            this._autocompleteComponent.bind(this._textAreaElement);
            this._isAutocompleteComponentBound = true;
        }
    }
}
